"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var state = {
  activePath: '',
  tagNavList: [],
  breadcrumbArr: [],
  isLocal: false,
  homeRoute: null
};
var mutations = {
  setActivePath: function setActivePath(state, path) {
    state.activePath = path;
  },
  setTagNavList: function setTagNavList(state, list) {
    state.tagNavList = list || [];
  },
  addTag: function addTag(state, _ref) {
    var route = _ref.route;
    var list = _toConsumableArray(state.tagNavList);
    if (route && !list.find(function (r) {
      return r.path === route.path;
    })) {
      list.push(route);
    }
    state.tagNavList = list;
  },
  setBreadCrumb: function setBreadCrumb(state, route) {
    state.breadcrumbArr = route && route.meta && route.meta.breadcrumb || [];
  },
  setLocal: function setLocal(state, val) {
    state.isLocal = val;
  },
  setHomeRoute: function setHomeRoute(state, route) {
    state.homeRoute = route;
  },
  closeTag: function closeTag(state, route) {
    state.tagNavList = state.tagNavList.filter(function (r) {
      return r.path !== route.path;
    });
  }
};
var actions = {
  addTagNavList: function addTagNavList(_ref2, route) {
    var state = _ref2.state,
      commit = _ref2.commit;
    var list = _toConsumableArray(state.tagNavList);
    if (!list.find(function (r) {
      return r.path === route.path;
    })) {
      list.push(route);
    }
    commit('setTagNavList', list);
  },
  delTagNavList: function delTagNavList(_ref3, route) {
    var state = _ref3.state,
      commit = _ref3.commit;
    commit('setTagNavList', state.tagNavList.filter(function (r) {
      return r.path !== route.path;
    }));
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};